/**
 * Created by idea on 20/03/2017.
 */
export class Owner{
    constructor(
        public id : number,
        public social_name : string,
        public social_type : string,
        public social_id : string,
        public icheck_id : string,
        public device_id : string,
        public avatar: string
    ){

    }
}


// WEBPACK FOOTER //
// /app/src/app/common/models/Owner.ts